// extracted by mini-css-extract-plugin
export default {"LoadError":"bfv_a bii_qs bii_a bii_w bii_j bii_q","LoadError__icon":"bfv_b bii_vl bii_fm bii_sw","LoadError__message":"bfv_c bii_fm bii_tr"};